module.exports = __webpack_public_path__ + "media/img/illustrations/icons/shift-type-agency-sent-92dc89c5334ae0a536cfdc557b7bd6b9.svg";